import React from "react";

interface activeRowLineProp {
  isActive: boolean;
}
export default function ActiveRowLine(props: activeRowLineProp) {
  return (
    <>
      {props.isActive ? (
        <span className="mr-1 h-4/5 w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
      ) : (
        <span className="mr-1 h-4/5 w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
      )}
    </>
  );
}
